import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className, AwaitModules, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ColumnKey_LeftColumn, PanelKey_EventFeed } from '../../../_shared.js';
import { ICONS } from '@app/styles';
import './AdvisorPanel_EventFeed.scss';
import { Board_EventFeed } from '../../../_enum/advisor-board/index.js';
import { ModuleFE_RuntimeEncounterFeed } from '../../../modules/runtime/index.js';
import { Component_EncounterFeed } from '../../components/encounter-feed/Component_EncounterFeed/Component_EncounterFeed.js';
export class AdvisorPanel_EventFeed extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_EventFeed,
    };
    //######################### Life Cycle #########################
    __onAdvisorBoardUpdated = (updatedColumns) => {
        if (updatedColumns.includes(ColumnKey_LeftColumn))
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__event-feed', Board_EventFeed.isOpen() && 'open');
    }
    onPanelClick = () => {
        Board_EventFeed.open();
    };
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        return _jsxs(LL_V_L, { className: 'header-main', children: [_jsx("div", { className: 'title', children: "Events" }), _jsx("div", { className: 'sub-title', children: "Your complete timeline and latest notifications" })] });
    };
    renderHeader_Tail = () => {
        if (!Board_EventFeed.isOpen())
            return;
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => Board_EventFeed.close() });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => {
        return _jsx(AwaitModules, { modules: [ModuleFE_RuntimeEncounterFeed], Component: () => this.render_Feed() });
    };
    render_Feed = () => {
        const feedItems = ModuleFE_RuntimeEncounterFeed.getFeedItems();
        return _jsxs(LL_V_L, { className: 'feed-wrapper', children: [!!feedItems.today.length && _jsxs(_Fragment, { children: [_jsx("div", { className: 'feed-wrapper__title', children: _jsx("span", { children: "Today" }) }), _jsx(Component_EncounterFeed, { feedItems: feedItems.today, renderContext: 'event-log' })] }), !!feedItems.older.length && _jsxs(_Fragment, { children: [_jsx("div", { className: 'feed-wrapper__title', children: _jsx("span", { children: "Older" }) }), _jsx(Component_EncounterFeed, { feedItems: feedItems.older, renderContext: 'event-log' })] })] });
    };
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_EventFeed.js.map